import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { supabase } from './supabase';
import { useAppResumeAuth } from './hooks/useAppResumeAuth';
import { installDevGlobalClickDebug } from './devClickDebug';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Plans from './pages/Plans';
import Account from './pages/Account';
import SelectPlan from './pages/SelectPlan';
import Payment from './pages/Payment';
import SecurePaymentForm from './components/SecurePaymentForm';
import PaymentWarning from './pages/PaymentWarning';
import Dashboard from './pages/Dashboard';
import ClientRegister from './pages/ClientRegister';
import ClientLogin from './pages/ClientLogin';
import ClientDashboard from './pages/ClientDashboard';
import TeamMemberLogin from './pages/TeamMemberLogin';
import TeamMemberRegister from './pages/TeamMemberRegister';
import TeamMemberDashboard from './pages/TeamMemberDashboard';
import Invoice from './pages/Invoice';
import StripeReturn from './pages/StripeReturn';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import VerifyEmail from './pages/VerifyEmail';
import DevSupabasePipelineDiag from './pages/DevSupabasePipelineDiag';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppContent() {
  const location = useLocation();
  
  // Don't show navbar on client portal, team portal, or dashboard (dashboard has its own top bar)
  const isClientPortal = location.pathname.startsWith('/client-');
  const isTeamPortal = location.pathname.startsWith('/team-');
  const isDashboard = location.pathname.startsWith('/dashboard');
  const showNavbar = !isClientPortal && !isTeamPortal && !isDashboard;

  return (
    <div className="App">
      {showNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/plans" element={<Plans />} />
        <Route path="/account" element={<Account />} />
        <Route path="/select-plan" element={<SelectPlan />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/secure-payment" element={<SecurePaymentForm />} />
        <Route path="/payment-warning" element={<PaymentWarning />} />
        <Route path="/dashboard" element={<Dashboard />}>
          <Route path=":section" element={<Dashboard />} />
        </Route>
        <Route path="/dashboard" element={<Navigate to="/dashboard/overview" replace />} />
        <Route path="/invoice" element={<Invoice />} />
        <Route path="/billing/return" element={<StripeReturn />} />
        {/* Client Portal Routes */}
        <Route path="/client-register" element={<ClientRegister />} />
        <Route path="/client-login" element={<ClientLogin />} />
        <Route path="/client-dashboard" element={<ClientDashboard />} />
        {/* Team Member Portal Routes */}
        <Route path="/team-login" element={<TeamMemberLogin />} />
        <Route path="/team-register" element={<TeamMemberRegister />} />
        <Route path="/team-dashboard" element={<TeamMemberDashboard />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/dev/supabase-pipeline" element={<DevSupabasePipelineDiag />} />
      </Routes>
    </div>
  );
}

function App() {
  useAppResumeAuth(supabase);
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    if (window.localStorage?.getItem('DEVELLO_GLOBAL_CLICK_DEBUG') !== '1') return undefined;
    return installDevGlobalClickDebug();
  }, []);
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App; 